import USB from './usb.svg';
import Wifi from './wifi.svg';

export default {
  USB,
  Wifi,
};
